import { Card } from 'antd';
import { CSSProperties } from 'react';
import { MdRemoveCircleOutline } from 'react-icons/md';

interface IAccountCard {
  title: string;
  onRemove: () => void;
  children: React.ReactNode;
  style?: CSSProperties;
}

const AccountCard: React.FC<IAccountCard> = ({ title, children, onRemove, style }) => {
  return (
    <Card
      style={{
        width: '160px',
        background: 'radial-gradient(circle at top left, #0d3b47, #031a21 60%)',
        boxShadow: '0 10px 22px rgba(0,0,0,0.55)',
        border: '1px solid rgba(255, 255, 255, 0.12)',
        color: 'white',
        ...style,
      }}
      styles={{
        header: {
          minHeight: '35px',
          padding: '0px 1rem',
          fontSize: '14px',
          borderBottom: 'none',
          color: 'white',
        },
        body: { padding: '.5rem 1rem' },
      }}
      extra={
        <MdRemoveCircleOutline
          style={{ cursor: 'pointer', marginTop: '5px' }}
          color="white"
          size={16}
          onClick={onRemove}
        />
      }
      title={title}
    >
      {children}
    </Card>
  );
};

export default AccountCard;
